export const downloadFile = (
  fileName: string,
  contentType: string,
  content: ArrayBuffer
) => {
  const newBlob = new Blob([content], {
    type: contentType,
  });
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(newBlob);
  link.setAttribute("download", fileName);
  link.click();
  window.URL.revokeObjectURL(link.href);
};

export const openFile = (contentType: string, content: ArrayBuffer) => {
  const newBlob = new Blob([content], {
    type: contentType,
  });
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(newBlob);
  link.setAttribute("target", "_blank");
  link.click();
  window.URL.revokeObjectURL(link.href);
};
